module.exports = __webpack_public_path__ + "img/30.dde642c6.jpg";